import { Checkbox, Field, NumericInput, RadioGroup, TextOutput } from 'Components/Core';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { GaugeMoistureContentDeterminedBy } from '../../types';

const Component: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  let DeterminedByMoistureDensity = useSelector(
    pipe(
      createWorksheetSelector!('GaugeMoistureContentDeterminedBy'),
      (d) => d === GaugeMoistureContentDeterminedBy.FromMoistureDensity
    )
  );
  let CalculateDensityResultChecked = useSelector(createWorksheetSelector!('CalculateDensityResult'));
  return (
    <>
      <Field input={<Checkbox />} name="CalculateDensityResult" simpleValue />
      <ListFieldSection>
        <Field input={<NumericInput />} name="Readings[0].DensityTestCount" />
        <Field input={<NumericInput />} name="Readings[0].MoistureTestCount" />
        <Field input={<TextOutput />} name="Readings[0].DensityCountRatio" />
        <Field input={<TextOutput />} name="Readings[0].MoistureCountRatio" />
        <Field input={<TextOutput />} name="CalibrationEquation" visible={CalculateDensityResultChecked} />
        <Field input={CalculateDensityResultChecked ? <TextOutput /> : <NumericInput />} name="WetDensity" />
        <Field
          input={<RadioGroup />}
          name="GaugeMoistureContentDeterminedBy"
          options={[
            { label: 'Directly by Gauge', value: GaugeMoistureContentDeterminedBy.Directly },
            { label: 'From Moisture Density', value: GaugeMoistureContentDeterminedBy.FromMoistureDensity },
          ]}
        />
        <Field input={<NumericInput />} name="MoistureDensity" visible={DeterminedByMoistureDensity} />
        <Field input={DeterminedByMoistureDensity ? <TextOutput /> : <NumericInput />} name="MoistureContent" />
      </ListFieldSection>
    </>
  );
};

const AsNfdReading = withInjectedProps(Component);

export { AsNfdReading };
export default AsNfdReading;
